package com.vizio.redwolf.auth.model

import kotlinx.serialization.Serializable
import kotlin.js.JsExport

@Serializable
@JsExport
data class WalmartLoginViaSetupCodeRequestInfo(
    val authorizationCode: String,
    val redirectUri: String,
    val setupCode: String,
    val reCaptchaToken: String? = null
)

@Serializable
@JsExport
internal data class WalmartLoginViaSetupCodeClientRequestInfo(
    val authorizationCode: String,
    val redirectUri: String,
    val setupCode: String,
    val reCaptchaToken: String? = null,
    val messageToken: String? = null
)